export default __webpack_public_path__ + "static/media/close.445cff73.svg";